import { styled, keyframes, Typography } from '@mui/material';
import Logo from '@assets/softplus/logo.svg?react';

export const FormInstruction = styled(Typography)`
  color: ${({ theme }) => theme.palette.fixed.white};
  font-size: 12px;
  margin-top: 4px;
  line-height: 16px;
`;

export const LogoStyle = styled(Logo)`
  width: 217px;
  height: 106px;
  color: ${({ theme }) => theme.palette.fixed.white};
`;

export const UserProfile = styled('div')`
  border-radius: 64px;
  background-color: ${(props) => props.theme.palette.primary['01']};
  width: 128px;
  height: 128px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    width: 96px;
    height: 96px;
    border-radius: 48px;
  }
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  justify-content: center;
  gap: 20px;

  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);

  padding: 96px;
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    z-index: 1;
  }

  &::before {
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.5),
      transparent
    );
  }

  &::after {
    top: 0;
    left: 0;
    width: 1px;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.4),
      transparent,
      rgba(255, 255, 255, 0.1)
    );
  }

  @media (max-width: 768px) {
    width: 90%;
    padding: 64px;
  }

  @media (max-width: 480px) {
    width: 80%;
    padding: 32px 24px;
    gap: 16px;
  }
`;

// Animações
const waveMovementAnimation = keyframes`
  0% { background-position: 0% 100%; }
  100% { background-position: 100% 0%; }
`;

const waveDrawAnimation = keyframes`
  0% {
    clip-path: inset(0 0 0 100%);
    opacity: 0.2;
  }
  100% {
    clip-path: inset(0 0 0 0%);
    opacity: 0.7;
  }
`;

const waveGrowAnimation = keyframes`
  0% { transform: scale(1); opacity: 0.6; }
  50% { transform: scale(1.03); opacity: 0.8; }
  100% { transform: scale(1); opacity: 0.6; }
`;

export const Container = styled('div')`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    45deg,
    hsl(240deg 100% 11%) 5%,
    hsl(230deg 100% 16%) 19%,
    hsl(229deg 100% 21%) 27%,
    hsl(229deg 100% 27%) 34%,
    hsl(229deg 100% 33%) 40%,
    hsl(229deg 100% 39%) 45%,
    hsl(230deg 97% 45%) 51%,
    hsl(221deg 100% 46%) 56%,
    hsl(215deg 100% 44%) 62%,
    hsl(210deg 100% 41%) 68%,
    hsl(204deg 100% 37%) 75%,
    hsl(196deg 100% 32%) 83%,
    hsl(189deg 91% 30%) 100%
  );
  background-size: 400% 400%;
  animation: ${waveMovementAnimation} 10s ease infinite alternate;

  .waves {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;

    background-image: url('/wave-before.svg'), url('/wave-after.svg');
    background-repeat: no-repeat, no-repeat;
    background-position:
      center center,
      center center;
    background-size: cover, cover;

    animation:
      ${waveDrawAnimation} 5s ease forwards,
      ${waveMovementAnimation} 30s ease-in-out infinite alternate,
      ${waveGrowAnimation} 10s ease-in-out infinite alternate;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-height: 500px) {
    align-items: flex-start;
    padding-top: 40px;
  }
`;

export const ForgetPasswordButton = styled('div')`
  a {
    overflow: hidden;
    position: relative;
    display: inline-block;
    font-size: 1rem;

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }

  a::before,
  a::after {
    content: '';
    position: absolute;
    width: 100%;
    left: 0;
  }

  a::before {
    background-color: ${(props) => props.theme.palette.secondary.main};
    height: 2px;
    bottom: 0;
    transform-origin: 100% 50%;
    transform: scaleX(0);
    transition: transform 0.3s cubic-bezier(0.76, 0, 0.24, 1);
  }

  a:hover::before {
    transform-origin: 0% 50%;
    transform: scaleX(1);
  }

  a span {
    display: inline-block;
    transition: transform 0.3s cubic-bezier(0.76, 0, 0.24, 1);
  }

  .MuiTypography-root {
    color: ${({ theme }) => theme.palette.fixed.white};
    font-weight: 500;
    &:hover {
      color: ${({ theme }) => theme.palette.secondary.main};
      cursor: pointer;
    }
  }
`;
